var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('h1',[_vm._v("Animal")]),_c('p',[_vm._v("blabla")]),_c('router-link',{attrs:{"to":"/models"}},[_vm._v("Commencer")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }